import { rem } from "polished";
import styled from "styled-components";

export const PanelDark = styled.div`
  background-color: ${({ theme }) => theme.colours.itemPanel.background};
  border-radius: ${rem("8px")};
  padding: ${rem("20px")};
`;
